/* Suivi maison des modules du thème (menu, recherche, panier, commande express, pages vues)
   → même pipeline que les pages générées : edge page-analytics → marketing.page_sessions / page_events.
   Mêmes identifiants (pa_vid, pa_sid) que page_analytics.js : un visiteur = une même personne partout.
   Les scripts du thème appellent T(module, action, cible, data, once) → window.ccTrack, mis en file (__ccq) tant que ce fichier n'est pas chargé. */
(function () {
  var queue = window.__ccq || [];
  window.ccTrack = function () {};
  window.__ccq = { push: function () {} };
  try {
    if (!/coiffissimo-professional\.com$|247b54\.myshopify\.com$/.test(location.hostname)) return;
    var Q = new URLSearchParams(location.search);
    function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) {} return null; }
    function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) {} return null; }
    if (Q.get('pa_test') === '1') ss('pa_test', '1');
    var TEST = ss('pa_test') === '1';
    var role = window.Shopify && Shopify.theme && Shopify.theme.role;
    if (!TEST && (navigator.webdriver || Q.has('preview_theme_id') || (window.Shopify && Shopify.designMode) || (role && role !== 'main'))) return;

    var EP = 'https://hfgehqbswyeiqxxksbhx.supabase.co/functions/v1/page-analytics';
    function allowed() { try { var cp = window.Shopify && Shopify.customerPrivacy; if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false; } catch (e) {} return true; }
    function rid() { try { return crypto.randomUUID(); } catch (e) { return 'x' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12); } }
    var vid = ls('pa_vid'); if (!vid) { vid = rid(); ls('pa_vid', vid); }
    var sid = ss('pa_sid'), last = +ss('pa_last') || 0; if (!sid || Date.now() - last > 1800000) { sid = rid(); ss('pa_sid', sid); }
    ss('pa_last', String(Date.now()));
    var page = location.pathname.replace(/^\/pages\//, '').replace(/\/+$/, '') || '/';
    function cid() { try { return (window.__st && __st.cid) || (window.ShopifyAnalytics && ShopifyAnalytics.meta.page.customerId) || null; } catch (e) { return null; } }
    var vw = innerWidth;
    var S = { sid: sid, vid: vid, page: page, url: location.href.slice(0, 500), referrer: document.referrer.slice(0, 500),
      utm_source: TEST ? 'test' : Q.get('utm_source'), utm_medium: Q.get('utm_medium'), utm_campaign: Q.get('utm_campaign'), utm_content: Q.get('utm_content'), utm_term: Q.get('utm_term'),
      device: vw < 750 ? 'mobile' : vw < 990 ? 'tablet' : 'desktop', vw: vw, vh: innerHeight, customer_id: cid(), ua: navigator.userAgent.slice(0, 300),
      active_ms: 0, max_scroll_pct: 0, module_ms: {}, added: false };

    /* ---------- file d'envoi ---------- */
    var q = [];
    function push(e) { e.t = Date.now(); e.vw = innerWidth; q.push(e); if (q.length >= 40) flush(); }
    function flush(beacon) {
      if (!allowed()) { q = []; return; }
      if (!q.length) return;
      S.customer_id = S.customer_id || cid();
      var body = JSON.stringify({ session: S, events: q.splice(0, 150) });
      ss('pa_last', String(Date.now()));
      try { if (beacon && navigator.sendBeacon && navigator.sendBeacon(EP, new Blob([body], { type: 'text/plain' }))) return; } catch (e) {}
      try { var f = rawWin().fetch || fetch; f(EP, { method: 'POST', body: body, headers: { 'Content-Type': 'text/plain' }, keepalive: true, mode: 'cors' }).catch(function () {}); } catch (e) {}
    }
    setInterval(flush, 10000);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(true); });
    addEventListener('pagehide', function () { flush(true); });

    /* ---------- API ---------- */
    var onceSeen = {}, deb = {}, lastClick = null, lastQ = '';
    function clean(o) { var r = {}; Object.keys(o || {}).forEach(function (k) { var v = o[k]; if (v === undefined || v === null || v === '') return; r[k] = typeof v === 'string' ? v.replace(/\s+/g, ' ').trim().slice(0, 160) : v; }); return r; }
    function track(module, action, cible, data, once) {
      if (once) { if (onceSeen[once]) return; onceSeen[once] = 1; }
      var d = clean(data); if (cible !== undefined && cible !== null && cible !== '') d.cible = String(cible).replace(/\s+/g, ' ').trim().slice(0, 160);
      push({ type: 'ui', module: module, label: action, data: d });
      if (module === 'panier' || module === 'express') tagCart();
      if (action === 'passer_commande' || action === 'ajouter_au_panier' || action === 'valider') flush(true);
    }
    window.ccTrack = function (module, action, cible, data, once) {
      try {
        if (module === 'recherche' && action === 'saisie') {
          var s = String(cible || '').trim(); if (s.length < 2) return;
          lastQ = s; clearTimeout(deb.q);
          deb.q = setTimeout(function () { track(module, action, s, data); }, 1200);
          return;
        }
        track(module, action, cible, data, once);
      } catch (e) {}
    };
    window.__ccq = { push: function (a) { window.ccTrack.apply(null, a); } };

    /* ---------- erreurs : JS des scripts cc-* (panier, menu, recherche, express) et promesses rejetées ---------- */
    var errN = 0;
    function err(kind, msg, src) {
      if (errN >= 10) return; errN++;
      track('erreur', kind, String(msg || '').slice(0, 160), { source: String(src || '').split('?')[0].split('/').pop(), chemin: location.pathname });
      flush();
    }
    addEventListener('error', function (e) { var f = e.filename || ''; if (/\/cc-[a-z-]+\.js/.test(f)) err('js', e.message, f); }, true);
    addEventListener('unhandledrejection', function (e) {
      var r = e.reason, st = (r && r.stack) || '', m = (r && r.message) || String(r);
      var f = st.match(/\/cc-[a-z-]+\.js/); if (f) err('promesse', m, f[0]);
    });

    /* ---------- page vue ---------- */
    var pt = ''; try { pt = (window.ShopifyAnalytics && ShopifyAnalytics.meta.page.pageType) || ''; } catch (e) {}
    push({ type: 'pageview', module: null, label: document.title.slice(0, 120), data: clean({ type: pt, chemin: location.pathname, q: Q.get('q') }) });
    setTimeout(flush, 3000);

    /* ---------- rattachement aux commandes : _pa_vid dans les attributs du panier (iframe : invisible des apps) ---------- */
    function rawWin() {
      var f = document.getElementById('ccraw');
      if (!f) { f = document.createElement('iframe'); f.id = 'ccraw'; f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1; f.style.display = 'none'; document.body.appendChild(f); }
      return f.contentWindow || window;
    }
    var tagged = false;
    function tagCart() {
      if (tagged) return; tagged = true;
      setTimeout(function () {
        try {
          var w = rawWin();
          w.fetch(location.origin + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
            if (!c.item_count || (c.attributes && c.attributes._pa_vid === vid)) { if (!c.item_count) tagged = false; return; }
            return w.fetch(location.origin + '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _pa_vid: vid } }) });
          }).catch(function () { tagged = false; });
        } catch (e) { tagged = false; }
      }, 1500);
    }

    /* ---------- clics délégués ---------- */
    function pname(el) { if (!el) return ''; var c = el.cloneNode(true); c.querySelectorAll('.cce-badge').forEach(function (x) { x.remove(); }); return txt(c); }
    function txt(el) { return el ? (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120) : ''; }
    function zone() { return innerWidth < 990 ? 'mobile' : 'ordinateur'; }
    function moduleOf(el) {
      if (el.closest('#cc-cart')) return 'panier';
      if (el.closest('[data-ccs-panel],[data-ccs-mobile],[data-ccs-page],.ccm-search')) return 'recherche';
      if (el.closest('[data-cce]')) return 'express';
      if (el.closest('[data-ccm]')) return 'menu';
      if (el.closest('#hpn')) return 'home';
      return location.pathname.indexOf('/products/') === 0 ? 'fiche' : 'page';
    }
    function lineName(b) { var l = b.closest('.cc-line'); return txt(l && l.querySelector('.cc-t')); }
    function rank(container, a) { var l = [].slice.call(container.querySelectorAll('[data-ccs-link],[data-ccs-all]')); var i = l.indexOf(a); return i < 0 ? null : i + 1; }

    document.addEventListener('click', function (e) {
      try {
        var el = e.target; if (!el || el.nodeType !== 1) return;
        var m = moduleOf(el), b;
        lastClick = { m: m, t: Date.now() };

        if (m === 'panier') {
          if (!e.isTrusted && el.closest('[name="checkout"]')) return;
          if ((b = el.closest('#nvd-with-checkout-btn,[name="checkout"]'))) return track('panier', 'passer_commande', txt(b), { protection: !!document.querySelector('#cc-cart #nvd-with-checkout-btn'), total: txt(document.querySelector('#cc-cart .cc-sum-tot b')) });
          if ((b = el.closest('#nvd-without-checkout-btn,[data-cc-noins]'))) return track('panier', 'sans_protection', txt(b));
          if (el.closest('[data-cc-close]')) return track('panier', 'fermeture');
          if (el.closest('[data-cc-oxy]')) return track('panier', 'alerte_oxydant_clic');
          if ((b = el.closest('[data-cc-addq]'))) return track('panier', 'palier_ajout', txt(b), { variant_id: +b.dataset.ccAddq, quantite: +b.dataset.q });
          if ((b = el.closest('[data-cc-forgot]'))) return track('panier', 'oubli_ajout', txt(b), { variant_id: +b.dataset.ccForgot });
          if ((b = el.closest('[data-cc-vpapply]'))) {
            var rows = [].slice.call(document.querySelectorAll('#cc-cart .cc-vp-row.on')).map(function (r) { return txt(r); }).join(' | ');
            return track('panier', 'panneau_valider', txt(document.querySelector('#cc-cart .cc-vp-h b')), { lignes: rows, compteur: txt(document.querySelector('#cc-cart .cc-vp-tally b')) });
          }
          if (el.closest('[data-cc-vpclose]')) return track('panier', 'panneau_fermer');
          if ((b = el.closest('[data-cc-vp]'))) return track('panier', 'panneau_ouvrir', b.dataset.ccVp, { depuis: b.dataset.from || 'ligne' });
          if ((b = el.closest('[data-cc-q]'))) return track('panier', b.dataset.ccQ === '1' ? 'quantite_plus' : 'quantite_moins', lineName(b), { variante: txt(b.closest('.cc-shade') && b.closest('.cc-shade').querySelector('.cc-sn')) });
          if ((b = el.closest('[data-cc-rm]'))) return track('panier', 'retrait', lineName(b));
          if ((b = el.closest('[data-cc-rc]') || (el.closest('.cc-rc-i') ? el.closest('.cc-rc-i').querySelector('[data-cc-rc]') : null))) return track('panier', b.closest('.cc-rc.on') ? 'suggestion_retrait' : 'suggestion_clic', b.dataset.name, { promo: b.dataset.promo || undefined });
          if (el.closest('[data-cc-oxyadd]')) return track('panier', 'alerte_oxydant_ajout');
          if ((b = el.closest('[data-cc-tog]'))) return track('panier', 'deplier', txt(b));
          if ((b = el.closest('a[href]'))) return track('panier', 'lien', txt(b), { href: b.getAttribute('href') });
          return;
        }
        if (m === 'recherche') {
          var box = el.closest('[data-ccs-panel],[data-ccs-mobile],[data-ccs-page]') || document;
          var inp = document.querySelector('[data-ccs-mobile]:not([hidden]) input[name="cc_q"]') || document.querySelector('.ccm-search input[name="cc_q"]');
          var cq = lastQ || (inp && inp.value) || Q.get('q') || '';
          if ((b = el.closest('[data-ccs-link]'))) return track('recherche', 'resultat_clic', txt(b), { q: cq, rang: rank(box, b), type: (b.className || '').split(' ')[0], href: b.getAttribute('href'), zone: zone() });
          if ((b = el.closest('[data-ccs-all]'))) return track('recherche', 'voir_tout', txt(b), { q: cq, zone: zone() });
          if ((b = el.closest('[data-ccs-q]'))) return track('recherche', 'suggestion_clic', b.getAttribute('data-ccs-q'), { zone: zone() });
          if ((b = el.closest('[data-ccs-ig]'))) return track('recherche', 'filtre_gamme', txt(b), { q: cq });
          if ((b = el.closest('[data-ccs-page] button, [data-ccs-page] label'))) return track('recherche', 'page_filtre', txt(b), { q: cq });
          return;
        }
        if (m === 'express') {
          if ((b = el.closest('.cce-go'))) return track('express', 'ajouter_au_panier', txt(document.querySelector('[data-cce] .cce-tot b:last-child, [data-cce] .cce-tot span:last-child')) || txt(document.querySelector('[data-cce] .cce-tot')), { articles: txt(document.querySelector('[data-cce] .cce-sh span')), zone: zone() });
          if ((b = el.closest('.cce-chips > button'))) return track('express', 'filtre_categorie', txt(b));
          if ((b = el.closest('.cce-step button'))) {
            var p = b.closest('.cce-p'), v = b.closest('.cce-v');
            return track('express', b.dataset.d === '1' ? 'quantite_plus' : 'quantite_moins', pname(p && p.querySelector('.cce-pn')), { variante: txt(v && v.querySelector('.cce-vl')) });
          }
          if ((b = el.closest('.cce-fv'))) return track('express', 'facette', txt(b));
          if ((b = el.closest('.cce-fold, .cce-gfold'))) return track('express', 'deplier', pname(b.closest('.cce-p') && b.closest('.cce-p').querySelector('.cce-pn')));
          if ((b = el.closest('.cce-pn'))) return track('express', 'fiche_produit', pname(b), { href: b.getAttribute('href') });
          if ((b = el.closest('.cce-sh button'))) return track('express', 'tout_vider');
          return;
        }
        if (m === 'home') {
          if ((b = el.closest('#hpn [data-tab]'))) return track('home', 'onglet', b.getAttribute('data-tab'));
          if ((b = el.closest('#hpn [data-grid] a[href]'))) {
            var g = b.closest('[data-grid]'), cardEl = b.parentElement, sec = g.closest('section'), tab = sec && sec.querySelector('[data-tab][aria-selected="true"]');
            return track('home', 'produit_clic', txt(cardEl.querySelector('b')), { onglet: tab ? tab.getAttribute('data-tab') : 'bestsellers', rang: [].indexOf.call(g.children, cardEl) + 1, promo: /Promotion/i.test(cardEl.textContent), href: b.getAttribute('href'), zone: zone() });
          }
          if ((b = el.closest('#hpn a[href]'))) return track('home', 'lien', txt(b), { href: b.getAttribute('href'), zone: zone() });
          return;
        }
        if (m === 'menu') {
          if ((b = el.closest('a[href]'))) {
            var li = b.closest('.ccm-li'), tl = li && (li.querySelector(':scope > .ccm-tl') || li.querySelector('.ccm-tl-t'));
            var href = b.getAttribute('href') || '';
            var action = b.closest('.ccm-logo') ? 'logo' : /commande-express/.test(href) ? 'commande_express' : /^tel:/.test(href) ? 'telephone' : /\/cart/.test(href) ? 'panier_icone' : 'lien';
            return track('menu', action, txt(b), { rubrique: txt(tl), type: (b.className || '').split(' ')[0], href: href, zone: zone() });
          }
          if ((b = el.closest('[data-ccm-back],[data-ccm-tabback]'))) return track('menu', 'retour');
          if ((b = el.closest('.ccm-tab'))) return track('menu', 'onglet', txt(b), { rubrique: txt(b.closest('.ccm-li') && b.closest('.ccm-li').querySelector(':scope > .ccm-tl')) });
        }
      } catch (x) {}
    }, { capture: true, passive: true });

    /* ---------- saisies ---------- */
    document.addEventListener('input', function (e) {
      var t = e.target; if (!t || !t.matches) return;
      if (t.matches('[data-cce-q]')) { clearTimeout(deb.f); deb.f = setTimeout(function () { var v = t.value.trim(); if (v.length >= 2) track('express', 'filtre_texte', v); }, 1200); }
    }, true);
    document.addEventListener('change', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      if (t.closest('.cce-sort')) track('express', 'tri', t.options && t.options[t.selectedIndex] ? t.options[t.selectedIndex].text : t.value);
      else if (t.closest('.cce-switch, .cce-only')) track('express', 'dans_la_commande', t.checked ? 'oui' : 'non');
      else if (t.closest('.cce-pump')) track('express', 'pompe', t.checked ? 'avec' : 'sans');
      else if (t.matches && t.matches('.cce-step input')) track('express', 'quantite_saisie', pname(t.closest('.cce-p') && t.closest('.cce-p').querySelector('.cce-pn')), { valeur: +t.value });
      else if (t.closest('[data-ccs-page]') && t.tagName === 'SELECT') track('recherche', 'page_tri', t.value);
    }, true);

    /* ---------- panier : variations (hors pages générées, déjà suivies par page_analytics.js) ---------- */
    var SYS = [49059516973383], NVD = /navidium|protection/i, snap = null, diffT = null;
    function readCart() {
      return rawWin().fetch(location.origin + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var m = {}; (c.items || []).forEach(function (i) {
          if (SYS.indexOf(i.variant_id) >= 0 || NVD.test(i.handle || '')) return;
          var k = i.variant_id; if (!m[k]) m[k] = { q: 0, t: (i.product_title + (i.variant_title ? ' · ' + i.variant_title : '')).slice(0, 120), p: i.final_price }; m[k].q += i.quantity;
        }); return m;
      });
    }
    function cartDiff() {
      if (window.__paOn) return;
      clearTimeout(diffT);
      diffT = setTimeout(function () {
        readCart().then(function (now) {
          if (!snap) { snap = now; return; }
          var c = lastClick && Date.now() - lastClick.t < 5000 ? lastClick : null, keys = {};
          Object.keys(snap).concat(Object.keys(now)).forEach(function (k) { keys[k] = 1; });
          Object.keys(keys).forEach(function (k) {
            var a = snap[k] ? snap[k].q : 0, b = now[k] ? now[k].q : 0; if (a === b) return; var it = now[k] || snap[k];
            if (b > a) S.added = true;
            push({ type: 'cart_change', module: c ? c.m : null, label: b === 0 ? 'retrait' : a === 0 ? 'ajout' : b > a ? 'plus' : 'moins',
              data: { variant_id: +k, produit: it.t, avant: a, apres: b, prix: it.p, cadeau: it.p === 0, auto: !c } });
          });
          snap = now; tagCart();
        }).catch(function () {});
      }, 900);
    }
    setTimeout(function () { if (!window.__paOn) readCart().then(function (m) { if (!snap) snap = m; }).catch(function () {}); }, 600);
    try { new PerformanceObserver(function (l) { l.getEntries().forEach(function (en) { if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(en.name)) cartDiff(); }); }).observe({ type: 'resource', buffered: false }); } catch (e) {}

    /* événements émis avant le chargement de ce fichier */
    (queue.length ? queue : []).forEach(function (a) { window.ccTrack.apply(null, a); });
  } catch (e) {}
})();
